import { EmployeeForSaveDto } from 'core/application/companies/getEmployeeForSave'

export enum HireDateRadioSelect {
  Date = 0,
  IDontKnow = 1,
}
export type FormData = EmployeeForSaveDto & {
  hireDateSelect?: HireDateRadioSelect
  minHireDate?: string
  benefitHistoryEffectiveDate?: string
}
